"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _index = require("../../constants/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DOWNLOAD_CLICKS = _index.eventTypes.DOWNLOAD_CLICKS;
var webInteractionTypes = _index.eventFieldValues.webInteractionTypes;
var setWebInteractionType = function setWebInteractionType(event) {
  var eventType = (0, _get2["default"])(event, 'event');
  var typeValue = eventType === DOWNLOAD_CLICKS ? webInteractionTypes.DOWNLOAD : webInteractionTypes.OTHER;
  (0, _set2["default"])(event, 'xdm.web.webInteraction.type', typeValue);
  return event;
};
var _default = exports["default"] = setWebInteractionType;